import { ChevronRight, Workflow } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export const AdminBuilderHeader = ({ flowName }: { flowName: string }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-background select-none">
      <div className="relative items-center flex h-[55px] w-full p-4 bg-muted/30">
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <Workflow className="h-5 w-5" />
          </Button>
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
          <h2 className="font-semibold tracking-tight">{flowName}</h2>
        </div>
      </div>
    </div>
  );
};
